import React, { useEffect, useState } from 'react';
import { Card, Col, Placeholder, Row } from 'react-bootstrap';
import Banderas from '../cliente/Banderas';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

const SubscriptionClientInfo = ({ idSuscripcion }) => {
    const { token } = useToken();
    const [info, setInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const ObtenerInfo = async () => {
        if (!idSuscripcion) return;
        setIsLoading(true);

        try {
            const response = await fetch(`/api/Suscripciones/ObtenerClienteInfo`, {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idSuscripcion: parseInt(idSuscripcion) })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const detalles = JSON.parse(data.detalles || '[]');
                    if (detalles.length > 0) {
                        setInfo(detalles[0]);
                    } else {
                        setInfo(null);
                    }
                } else {
                    toast.error(data.vMessage || 'Error al obtener información del cliente');
                }
            } else {
                toast.error('Error de red al obtener información del cliente');
            }
        } catch (error) {
            console.error("Error obteniendo info del cliente", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        ObtenerInfo();
    }, [idSuscripcion]);

    return (
        <Card className="border-0 shadow-sm rounded-3 mb-4 h-100" style={{ fontFamily: '"Open Sans", sans-serif' }}>
            <Card.Body className="p-4">
                <h6 className="fw-bold mb-4 d-flex align-items-center" style={{ fontSize: '1rem' }}>
                    <FontAwesomeIcon icon="user" className="text-primary me-2" />
                    Cliente
                    {!isLoading && info?.idClienteAkasia && (
                        <span className="ms-2 border bg-white text-muted px-2" style={{ fontSize: '0.85rem', fontWeight: 600, borderRadius: '4px', padding: '2px 6px' }}>
                            #{info.idClienteAkasia}
                        </span>
                    )}
                </h6>

                {/* SECCIÓN CLIENTE HEADER */}

                <Col className="px-0">
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex justify-content-center align-items-center" style={{ width: '48px', height: '48px' }}>
                            {isLoading ? (
                                <Placeholder as="div" animation="glow" style={{ width: '100%', height: '100%' }}>
                                    <Placeholder xs={12} className="rounded-circle h-100 w-100 bg-secondary" style={{ opacity: 0.5 }} />
                                </Placeholder>
                            ) : (
                                <img src="/img/cliente48.png" alt="Cliente" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                            )}
                        </div>

                        <div className="d-flex flex-column justify-content-center flex-grow-1">
                            <div className="d-flex align-items-center mb-1">
                                {isLoading ? (
                                    <Placeholder as="span" animation="glow" className="w-100">
                                        <Placeholder xs={6} bg="secondary" style={{ opacity: 0.5 }} />
                                    </Placeholder>
                                ) : (
                                    <a href={`/clientes/detalle/${info?.idClienteAkasia}`} target="_blank" rel="noopener noreferrer" className="fw-bold text-primary text-decoration-none text-uppercase" style={{ fontSize: '0.95rem' }}>
                                        {info ? `${info.vNombre} ${info.vApellidos}` : 'DESCONOCIDO'}
                                    </a>
                                )}
                            </div>

                            {isLoading ? (
                                <Placeholder as="span" animation="glow" className="w-100 mt-1">
                                    <Placeholder xs={5} bg="secondary" style={{ opacity: 0.5 }} />
                                </Placeholder>
                            ) : info?.vEmail ? (
                                <a href={`mailto:${info.vEmail}`} className="text-primary text-decoration-none" style={{ fontSize: '0.8rem' }}>
                                    {info.vEmail.toLowerCase()}
                                </a>
                            ) : (
                                <span className="text-muted fst-italic" style={{ fontSize: '0.8rem' }}>
                                    Sin correo registrado
                                </span>
                            )}
                        </div>
                    </div>
                </Col>


                <Row className="mb-3 border-bottom pb-2 mx-0 mt-2">
                    <Col xs={12} className="px-0">
                        <div className="text-muted fw-bold text-uppercase pb-1 pt-1" style={{ fontSize: '0.75rem', letterSpacing: '0.5px', lineHeight: '1.5' }}>Información de contacto</div>
                    </Col>
                </Row>

                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2 mx-0">
                    <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Razón Social</span>
                    <span className={`text-end text-uppercase ${isLoading ? '' : info?.vRazonSocial ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? (
                            <Placeholder as="span" animation="glow">
                                <Placeholder xs={5} bg="secondary" style={{ width: '80px' }} />
                            </Placeholder>
                        ) : (
                            info?.vRazonSocial || 'Sin razón social'
                        )}
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2 mx-0">
                    <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Teléfono Personal</span>
                    <span className={`text-end ${isLoading ? '' : info?.vTelefonoPersonal ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={4} bg="secondary" style={{ width: '80px' }} /></Placeholder> : (
                            <>
                                {info?.vTelefonoPersonal || 'Sin teléfono'}
                                {info?.vTelefonoPersonal && <img src="/img/whatsapp20.png" alt="WhatsApp" className="ms-2" />}
                            </>
                        )}
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2 mx-0">
                    <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>País</span>
                    <span className={`text-end text-uppercase ${isLoading ? '' : info?.vPais ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? <Placeholder as="span" animation="glow"><Placeholder xs={4} bg="secondary" style={{ width: '80px' }} /></Placeholder> : (
                            <>
                                {info?.vPais && <span className="me-2"><Banderas vPais={info.vPais} Height={20} /></span>}
                                {info?.vPais || 'Sin país'}
                            </>
                        )}
                    </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2 mx-0">
                    <span className="text-muted pe-3" style={{ fontSize: '0.85rem' }}>Estado/Provincia</span>
                    <span className={`text-end text-uppercase ${isLoading ? '' : info?.vEstadoDepProv ? 'fw-bold' : 'text-muted fst-italic'}`} style={{ fontSize: '0.85rem' }}>
                        {isLoading ? (
                            <Placeholder as="span" animation="glow">
                                <Placeholder xs={5} bg="secondary" style={{ width: '80px' }} />
                            </Placeholder>
                        ) : (
                            info?.vEstadoDepProv || 'Sin estado'
                        )}
                    </span>
                </div>

            </Card.Body>
        </Card>
    );
};

SubscriptionClientInfo.propTypes = {
    idSuscripcion: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SubscriptionClientInfo;
